import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { SequenceCard } from '@/components/sequences/SequenceCard';
import { useSequenceFilter } from '@/hooks/useSequenceFilter';

const PopularSequences = () => {
  // Use the proper sequence filter hook for real Supabase data
  const { sequences, isLoading } = useSequenceFilter();

  return (
    <section className="py-16 px-6 bg-muted/50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
          <div>
            <div className="text-sm text-primary font-medium mb-2">SYNCHRONIZED MAGIC</div>
            <h2 className="text-3xl md:text-4xl font-bold">Popular Sequences</h2>
            <p className="text-muted-foreground mt-2 max-w-2xl">
              Find and purchase synchronized light sequences created by talented display owners.
            </p>
          </div>
          <Link to="/sequences">
            <Button variant="link" className="md:self-end">
              View All Sequences
            </Button>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {isLoading ? (
            // Loading skeleton
            [...Array(8)].map((_, i) => (
              <div key={i} className="aspect-square bg-muted animate-pulse rounded-lg" />
            ))
          ) : (
            sequences.slice(0, 8).map(sequence => (
              <SequenceCard 
                key={sequence.id} 
                sequence={sequence}
              />
            ))
          )}
        </div>

        <div className="mt-12 text-center">
          <Link to="/sequences">
            <Button variant="outline" className="rounded-full px-8">
              Explore All Sequences
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PopularSequences;
